import React from 'react';
import Select, { components } from 'react-select';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <div className="flex items-center p-0 pointer-events-none">
        <i className="fa fa-chevron-down text-gray-700" />
      </div>
    </components.DropdownIndicator>
  );
};

export const GenericSelect = ({
  options,
  value,
  onChange,
  placeholder = 'Select an option...',
  hasError = false,
  className = '',
}) => {
  // Style customization to match the native select
  const customStyles = {
    control: (base, state) => ({
      ...base,
      fontSize: '14px',
      width: '100%',
      padding: '9px 12px',
      borderRadius: '30px', // rounded-full
      border: `1px solid ${hasError ? '#ef4444' : '#e0e0e0'}`, // border color with error state
      backgroundColor: 'white',
      boxShadow: 'none',
      '&:hover': {
        borderColor: hasError ? '#ef4444' : '#d1d5db',
      },
      minHeight: '44px', // matches py-[12px]
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 8px',
    }),
    singleValue: (base) => ({
      ...base,
      color: '#4f4f4f',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#9ca3af',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: '0.5rem',
      overflow: 'hidden',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? '#f3f4f6' : 'white',
      color: '#374151',
      padding: '8px 16px',
      '&:hover': {
        backgroundColor: '#f9fafb',
      },
      cursor: 'pointer',
    }),
  };

  return (
    <div className={`relative ${className}`}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        styles={customStyles}
        components={{ DropdownIndicator }}
        isSearchable={false}
        className="generic-select"
        classNamePrefix="generic-select"
      />
    </div>
  );
};
